{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "title": "SurveyJS Library json schema",
  "type": "object",
  "properties": {
    "locale": {
      "type": "string",
      "enum": [""]
    },
    "title": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "description": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "logo": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "logoWidth": {
      "type": "string"
    },
    "logoHeight": {
      "type": "string"
    },
    "logoFit": {
      "type": "string",
      "enum": ["none", "contain", "cover", "fill"]
    },
    "logoPosition": {
      "type": "string",
      "enum": ["none", "left", "right", "top", "bottom"]
    },
    "focusFirstQuestionAutomatic": {
      "type": "boolean"
    },
    "focusOnFirstError": {
      "type": "boolean"
    },
    "completedHtml": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "completedBeforeHtml": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "completedHtmlOnCondition": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/htmlconditionitem"
      }
    },
    "loadingHtml": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "pages": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/page"
      }
    },
    "elements": {
      "type": "array",
      "items": {
        "anyOf": [
          {
            "$ref": "#/definitions/matrixdropdownbase"
          },
          {
            "$ref": "#/definitions/matrixdropdown"
          },
          {
            "$ref": "#/definitions/matrixdynamic"
          },
          {
            "$ref": "#/definitions/matrix"
          },
          {
            "$ref": "#/definitions/expression"
          },
          {
            "$ref": "#/definitions/checkbox"
          },
          {
            "$ref": "#/definitions/tagbox"
          },
          {
            "$ref": "#/definitions/ranking"
          },
          {
            "$ref": "#/definitions/radiogroup"
          },
          {
            "$ref": "#/definitions/imagepicker"
          },
          {
            "$ref": "#/definitions/buttongroup"
          },
          {
            "$ref": "#/definitions/dropdown"
          },
          {
            "$ref": "#/definitions/textbase"
          },
          {
            "$ref": "#/definitions/text"
          },
          {
            "$ref": "#/definitions/comment"
          },
          {
            "$ref": "#/definitions/multipletext"
          },
          {
            "$ref": "#/definitions/nonvalue"
          },
          {
            "$ref": "#/definitions/html"
          },
          {
            "$ref": "#/definitions/image"
          },
          {
            "$ref": "#/definitions/empty"
          },
          {
            "$ref": "#/definitions/file"
          },
          {
            "$ref": "#/definitions/rating"
          },
          {
            "$ref": "#/definitions/boolean"
          },
          {
            "$ref": "#/definitions/signaturepad"
          },
          {
            "$ref": "#/definitions/paneldynamic"
          },
          {
            "$ref": "#/definitions/panel"
          }
        ]
      }
    },
    "triggers": {
      "type": "array",
      "items": {
        "anyOf": [
          {
            "$ref": "#/definitions/visibletrigger"
          },
          {
            "$ref": "#/definitions/completetrigger"
          },
          {
            "$ref": "#/definitions/setvaluetrigger"
          },
          {
            "$ref": "#/definitions/copyvaluetrigger"
          },
          {
            "$ref": "#/definitions/skiptrigger"
          },
          {
            "$ref": "#/definitions/runexpressiontrigger"
          }
        ]
      }
    },
    "calculatedValues": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/calculatedvalue"
      }
    },
    "surveyId": {
      "type": "string"
    },
    "surveyPostId": {
      "type": "string"
    },
    "surveyShowDataSaving": {
      "type": "boolean"
    },
    "cookieName": {
      "type": "string"
    },
    "sendResultOnPageNext": {
      "type": "boolean"
    },
    "showNavigationButtons": {
      "type": "string",
      "enum": ["none", "top", "bottom", "both"]
    },
    "showPrevButton": {
      "type": "boolean"
    },
    "showTitle": {
      "type": "boolean"
    },
    "showPageTitles": {
      "type": "boolean"
    },
    "showCompletedPage": {
      "type": "boolean"
    },
    "navigateToUrl": {
      "type": "string"
    },
    "navigateToUrlOnCondition": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/urlconditionitem"
      }
    },
    "questionsOrder": {
      "type": "string",
      "enum": ["initial", "random"]
    },
    "matrixDragHandleArea": {
      "type": "string",
      "enum": ["entireItem", "icon"]
    },
    "showPageNumbers": {
      "type": "boolean"
    },
    "showQuestionNumbers": {
      "type": "string",
      "enum": ["on", "onPage", "off"]
    },
    "questionTitleLocation": {
      "type": "string",
      "enum": ["top", "bottom", "left"]
    },
    "questionDescriptionLocation": {
      "type": "string",
      "enum": ["underInput", "underTitle"]
    },
    "questionErrorLocation": {
      "type": "string",
      "enum": ["top", "bottom"]
    },
    "showProgressBar": {
      "type": "string",
      "enum": ["off", "auto", "aboveheader", "belowheader", "bottom", "topbottom"]
    },
    "progressBarType": {
      "type": "string",
      "enum": ["pages", "questions", "requiredQuestions", "correctQuestions"]
    },
    "progressBarShowPageTitles": {
      "type": "boolean"
    },
    "progressBarShowPageNumbers": {
      "type": "boolean"
    },
    "progressBarInheritWidthFrom": {
      "type": "string",
      "enum": ["container", "survey"]
    },
    "showTOC": {
      "type": "boolean"
    },
    "tocLocation": {
      "type": "string",
      "enum": ["left", "right"]
    },
    "mode": {
      "type": "string",
      "enum": ["edit", "display"]
    },
    "storeOthersAsComment": {
      "type": "boolean"
    },
    "maxTextLength": {
      "type": "number"
    },
    "maxOthersLength": {
      "type": "number"
    },
    "goNextPageAutomatic": {
      "type": "boolean"
    },
    "allowCompleteSurveyAutomatic": {
      "type": "boolean"
    },
    "clearInvisibleValues": {
      "type": "string",
      "enum": ["none", "onComplete", "onHidden", "onHiddenContainer"]
    },
    "checkErrorsMode": {
      "type": "string",
      "enum": ["onNextPage", "onValueChanged", "onComplete"]
    },
    "validateVisitedEmptyFields": {
      "type": "boolean"
    },
    "textUpdateMode": {
      "type": "string",
      "enum": ["onBlur", "onTyping"]
    },
    "autoGrowComment": {
      "type": "boolean"
    },
    "allowResizeComment": {
      "type": "boolean"
    },
    "commentAreaRows": {
      "type": "number"
    },
    "startSurveyText": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "pagePrevText": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "pageNextText": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "completeText": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "previewText": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "editText": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "requiredText": {
      "type": "string"
    },
    "questionStartIndex": {
      "type": "string"
    },
    "questionTitlePattern": {
      "type": "string"
    },
    "questionTitleTemplate": {
      "oneOf": [
        {
          "type": "string"
        },
        {
          "$ref": "#/definitions/locstring"
        }
      ]
    },
    "firstPageIsStarted": {
      "type": "boolean"
    },
    "isSinglePage": {
      "type": "boolean"
    },
    "questionsOnPageMode": {
      "type": "string",
      "enum": ["standard", "singlePage", "questionPerPage"]
    },
    "showPreviewBeforeComplete": {
      "type": "string",
      "enum": ["noPreview", "showAllQuestions", "showAnsweredQuestions"]
    },
    "maxTimeToFinish": {
      "type": "number"
    },
    "maxTimeToFinishPage": {
      "type": "number"
    },
    "showTimerPanel": {
      "type": "string",
      "enum": ["none", "top", "bottom"]
    },
    "showTimerPanelMode": {
      "type": "string",
      "enum": ["page", "survey", "all"]
    },
    "widthMode": {
      "type": "string",
      "enum": ["auto", "static", "responsive"]
    },
    "gridLayoutEnabled": {
      "type": "boolean"
    },
    "width": {
      "type": "string"
    },
    "fitToContainer": {
      "type": "boolean"
    },
    "headerView": {
      "type": "string",
      "enum": ["basic", "advanced"]
    },
    "backgroundImage": {
      "type": "string"
    },
    "backgroundImageFit": {
      "type": "string",
      "enum": ["auto", "contain", "cover"]
    },
    "backgroundImageAttachment": {
      "type": "string",
      "enum": ["scroll", "fixed"]
    },
    "backgroundOpacity": {
      "type": "number"
    },
    "showBrandInfo": {
      "type": "boolean"
    }
  },
  "definitions": {
    "locstring": {
      "$id": "locstring",
      "type": "object",
      "properties": {
        "default": {
          "type": "string"
        },
        "en": {
          "type": "string"
        }
      }
    },
    "expressionitem": {
      "type": "object",
      "$id": "expressionitem",
      "properties": {
        "expression": {
          "type": "string"
        }
      }
    },
    "htmlconditionitem": {
      "type": "object",
      "$id": "htmlconditionitem",
      "allOf": [
        {
          "$ref": "expressionitem"
        },
        {
          "properties": {
            "html": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            }
          }
        }
      ]
    },
    "panelbase": {
      "type": "object",
      "$id": "panelbase",
      "properties": {
        "name": {
          "type": "string"
        },
        "elements": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "matrixdropdownbase"
              },
              {
                "$ref": "matrixdropdown"
              },
              {
                "$ref": "matrixdynamic"
              },
              {
                "$ref": "matrix"
              },
              {
                "$ref": "expression"
              },
              {
                "$ref": "checkbox"
              },
              {
                "$ref": "tagbox"
              },
              {
                "$ref": "ranking"
              },
              {
                "$ref": "radiogroup"
              },
              {
                "$ref": "imagepicker"
              },
              {
                "$ref": "buttongroup"
              },
              {
                "$ref": "dropdown"
              },
              {
                "$ref": "textbase"
              },
              {
                "$ref": "text"
              },
              {
                "$ref": "comment"
              },
              {
                "$ref": "multipletext"
              },
              {
                "$ref": "nonvalue"
              },
              {
                "$ref": "html"
              },
              {
                "$ref": "image"
              },
              {
                "$ref": "empty"
              },
              {
                "$ref": "file"
              },
              {
                "$ref": "rating"
              },
              {
                "$ref": "boolean"
              },
              {
                "$ref": "signaturepad"
              },
              {
                "$ref": "paneldynamic"
              },
              {
                "$ref": "panel"
              }
            ]
          }
        },
        "visible": {
          "type": "boolean"
        },
        "readOnly": {
          "type": "boolean"
        },
        "visibleIf": {
          "type": "string"
        },
        "enableIf": {
          "type": "string"
        },
        "requiredIf": {
          "type": "string"
        },
        "questionTitleWidth": {
          "type": "string"
        },
        "questionTitleLocation": {
          "type": "string",
          "enum": ["default", "top", "bottom", "left", "hidden"]
        },
        "layoutColumns": {
          "type": "array",
          "items": {
            "$ref": "panellayoutcolumn"
          }
        },
        "title": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "description": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "questionsOrder": {
          "type": "string",
          "enum": ["default", "initial", "random"]
        },
        "questionErrorLocation": {
          "type": "string",
          "enum": ["default", "top", "bottom"]
        }
      }
    },
    "question": {
      "type": "object",
      "$id": "question",
      "properties": {
        "type": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "state": {
          "type": "string",
          "enum": ["default", "collapsed", "expanded"]
        },
        "visible": {
          "type": "boolean"
        },
        "useDisplayValuesInDynamicTexts": {
          "type": "boolean"
        },
        "visibleIf": {
          "type": "string"
        },
        "width": {
          "type": "string"
        },
        "minWidth": {
          "type": "string"
        },
        "maxWidth": {
          "type": "string"
        },
        "colSpan": {
          "type": "number"
        },
        "effectiveColSpan": {
          "type": "number"
        },
        "startWithNewLine": {
          "type": "boolean"
        },
        "indent": {
          "type": "number",
          "enum": [0, 1, 2, 3]
        },
        "page": {
          "type": "string"
        },
        "title": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "titleLocation": {
          "type": "string",
          "enum": ["default", "top", "bottom", "left", "hidden"]
        },
        "description": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "descriptionLocation": {
          "type": "string",
          "enum": ["default", "underInput", "underTitle"]
        },
        "hideNumber": {
          "type": "boolean"
        },
        "valueName": {
          "type": "string"
        },
        "enableIf": {
          "type": "string"
        },
        "resetValueIf": {
          "type": "string"
        },
        "setValueIf": {
          "type": "string"
        },
        "setValueExpression": {
          "type": "string"
        },
        "defaultValue": {
          "type": "string"
        },
        "defaultValueExpression": {
          "type": "string"
        },
        "correctAnswer": {
          "type": "string"
        },
        "clearIfInvisible": {
          "type": "string",
          "enum": ["default", "none", "onComplete", "onHidden", "onHiddenContainer"]
        },
        "isRequired": {
          "type": "boolean"
        },
        "requiredIf": {
          "type": "string"
        },
        "requiredErrorText": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "errorLocation": {
          "type": "string",
          "enum": ["default", "top", "bottom"]
        },
        "readOnly": {
          "type": "boolean"
        },
        "validators": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "numericvalidator"
              },
              {
                "$ref": "textvalidator"
              },
              {
                "$ref": "answercountvalidator"
              },
              {
                "$ref": "regexvalidator"
              },
              {
                "$ref": "emailvalidator"
              },
              {
                "$ref": "expressionvalidator"
              }
            ]
          }
        },
        "bindings": {
          "type": "string"
        },
        "renderAs": {
          "type": "string"
        },
        "showCommentArea": {
          "type": "string"
        },
        "commentText": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "commentPlaceholder": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        }
      },
      "required": ["type", "name"]
    },
    "surveyvalidator": {
      "type": "object",
      "$id": "surveyvalidator",
      "properties": {
        "text": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        }
      }
    },
    "numericvalidator": {
      "type": "object",
      "$id": "numericvalidator",
      "allOf": [
        {
          "$ref": "surveyvalidator"
        },
        {
          "properties": {
            "minValue": {
              "type": "number"
            },
            "maxValue": {
              "type": "number"
            }
          }
        }
      ]
    },
    "textvalidator": {
      "type": "object",
      "$id": "textvalidator",
      "allOf": [
        {
          "$ref": "surveyvalidator"
        },
        {
          "properties": {
            "minLength": {
              "type": "number"
            },
            "maxLength": {
              "type": "number"
            },
            "allowDigits": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "answercountvalidator": {
      "type": "object",
      "$id": "answercountvalidator",
      "allOf": [
        {
          "$ref": "surveyvalidator"
        },
        {
          "properties": {
            "minCount": {
              "type": "number"
            },
            "maxCount": {
              "type": "number"
            }
          }
        }
      ]
    },
    "regexvalidator": {
      "type": "object",
      "$id": "regexvalidator",
      "allOf": [
        {
          "$ref": "surveyvalidator"
        },
        {
          "properties": {
            "regex": {
              "type": "string"
            },
            "caseInsensitive": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "emailvalidator": {
      "type": "object",
      "$id": "emailvalidator",
      "allOf": [
        {
          "$ref": "surveyvalidator"
        },
        {
          "properties": {}
        }
      ]
    },
    "expressionvalidator": {
      "type": "object",
      "$id": "expressionvalidator",
      "allOf": [
        {
          "$ref": "surveyvalidator"
        },
        {
          "properties": {
            "expression": {
              "type": "string"
            }
          }
        }
      ]
    },
    "matrixbase": {
      "type": "object",
      "$id": "matrixbase",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "columnsVisibleIf": {
              "type": "string"
            },
            "rowsVisibleIf": {
              "type": "string"
            },
            "columnMinWidth": {
              "type": "string"
            },
            "showHeader": {
              "type": "boolean"
            },
            "verticalAlign": {
              "type": "string",
              "enum": ["top", "middle"]
            },
            "alternateRows": {
              "type": "boolean"
            },
            "displayMode": {
              "type": "string",
              "enum": ["auto", "table", "list"]
            }
          }
        }
      ]
    },
    "matrixdropdownbase": {
      "type": "object",
      "$id": "matrixdropdownbase",
      "allOf": [
        {
          "$ref": "matrixbase"
        },
        {
          "properties": {
            "columns": {
              "type": "array",
              "items": {
                "$ref": "matrixdropdowncolumn"
              }
            },
            "columnLayout": {
              "type": "string",
              "enum": ["horizontal", "vertical"]
            },
            "transposeData": {
              "type": "boolean"
            },
            "detailElements": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "$ref": "matrixdropdownbase"
                  },
                  {
                    "$ref": "matrixdropdown"
                  },
                  {
                    "$ref": "matrixdynamic"
                  },
                  {
                    "$ref": "matrix"
                  },
                  {
                    "$ref": "expression"
                  },
                  {
                    "$ref": "checkbox"
                  },
                  {
                    "$ref": "tagbox"
                  },
                  {
                    "$ref": "ranking"
                  },
                  {
                    "$ref": "radiogroup"
                  },
                  {
                    "$ref": "imagepicker"
                  },
                  {
                    "$ref": "buttongroup"
                  },
                  {
                    "$ref": "dropdown"
                  },
                  {
                    "$ref": "textbase"
                  },
                  {
                    "$ref": "text"
                  },
                  {
                    "$ref": "comment"
                  },
                  {
                    "$ref": "multipletext"
                  },
                  {
                    "$ref": "nonvalue"
                  },
                  {
                    "$ref": "html"
                  },
                  {
                    "$ref": "image"
                  },
                  {
                    "$ref": "empty"
                  },
                  {
                    "$ref": "file"
                  },
                  {
                    "$ref": "rating"
                  },
                  {
                    "$ref": "boolean"
                  },
                  {
                    "$ref": "signaturepad"
                  },
                  {
                    "$ref": "paneldynamic"
                  },
                  {
                    "$ref": "panel"
                  }
                ]
              }
            },
            "detailPanelMode": {
              "type": "string",
              "enum": ["none", "underRow", "underRowSingle"]
            },
            "cellErrorLocation": {
              "type": "string",
              "enum": ["default", "top", "bottom"]
            },
            "detailErrorLocation": {
              "type": "string",
              "enum": ["default", "top", "bottom"]
            },
            "horizontalScroll": {
              "type": "boolean"
            },
            "choices": {
              "type": "array",
              "items": {
                "$ref": "itemvalue"
              }
            },
            "placeholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "keyDuplicationError": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "cellType": {
              "type": "string",
              "enum": [
                "dropdown",
                "checkbox",
                "radiogroup",
                "tagbox",
                "text",
                "comment",
                "boolean",
                "expression",
                "rating"
              ]
            },
            "columnColCount": {
              "type": "string",
              "enum": [0, 1, 2, 3, 4]
            },
            "allowAdaptiveActions": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "matrixdropdowncolumn": {
      "type": "object",
      "$id": "matrixdropdowncolumn",
      "properties": {
        "name": {
          "type": "string"
        },
        "title": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "cellHint": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "cellType": {
          "type": "string",
          "enum": [
            "default",
            "dropdown",
            "checkbox",
            "radiogroup",
            "tagbox",
            "text",
            "comment",
            "boolean",
            "expression",
            "rating"
          ]
        },
        "colCount": {
          "type": "string",
          "enum": [-1, 0, 1, 2, 3, 4]
        },
        "isRequired": {
          "type": "boolean"
        },
        "isUnique": {
          "type": "boolean"
        },
        "requiredErrorText": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "readOnly": {
          "type": "boolean"
        },
        "minWidth": {
          "type": "string"
        },
        "width": {
          "type": "string"
        },
        "visible": {
          "type": "boolean"
        },
        "visibleIf": {
          "type": "string"
        },
        "enableIf": {
          "type": "string"
        },
        "requiredIf": {
          "type": "string"
        },
        "resetValueIf": {
          "type": "string"
        },
        "setValueIf": {
          "type": "string"
        },
        "setValueExpression": {
          "type": "string"
        },
        "showInMultipleColumns": {
          "type": "boolean"
        },
        "validators": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "numericvalidator"
              },
              {
                "$ref": "textvalidator"
              },
              {
                "$ref": "answercountvalidator"
              },
              {
                "$ref": "regexvalidator"
              },
              {
                "$ref": "emailvalidator"
              },
              {
                "$ref": "expressionvalidator"
              }
            ]
          }
        },
        "totalType": {
          "type": "string",
          "enum": ["none", "sum", "count", "min", "max", "avg"]
        },
        "totalExpression": {
          "type": "string"
        },
        "totalFormat": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "totalDisplayStyle": {
          "type": "string",
          "enum": ["none", "decimal", "currency", "percent"]
        },
        "totalAlignment": {
          "type": "string",
          "enum": ["auto", "left", "center", "right"]
        },
        "totalCurrency": {
          "type": "string",
          "enum": [
            "AED",
            "AFN",
            "ALL",
            "AMD",
            "ANG",
            "AOA",
            "ARS",
            "AUD",
            "AWG",
            "AZN",
            "BAM",
            "BBD",
            "BDT",
            "BGN",
            "BHD",
            "BIF",
            "BMD",
            "BND",
            "BOB",
            "BOV",
            "BRL",
            "BSD",
            "BTN",
            "BWP",
            "BYN",
            "BZD",
            "CAD",
            "CDF",
            "CHE",
            "CHF",
            "CHW",
            "CLF",
            "CLP",
            "CNY",
            "COP",
            "COU",
            "CRC",
            "CUC",
            "CUP",
            "CVE",
            "CZK",
            "DJF",
            "DKK",
            "DOP",
            "DZD",
            "EGP",
            "ERN",
            "ETB",
            "EUR",
            "FJD",
            "FKP",
            "GBP",
            "GEL",
            "GHS",
            "GIP",
            "GMD",
            "GNF",
            "GTQ",
            "GYD",
            "HKD",
            "HNL",
            "HRK",
            "HTG",
            "HUF",
            "IDR",
            "ILS",
            "INR",
            "IQD",
            "IRR",
            "ISK",
            "JMD",
            "JOD",
            "JPY",
            "KES",
            "KGS",
            "KHR",
            "KMF",
            "KPW",
            "KRW",
            "KWD",
            "KYD",
            "KZT",
            "LAK",
            "LBP",
            "LKR",
            "LRD",
            "LSL",
            "LYD",
            "MAD",
            "MDL",
            "MGA",
            "MKD",
            "MMK",
            "MNT",
            "MOP",
            "MRO",
            "MUR",
            "MVR",
            "MWK",
            "MXN",
            "MXV",
            "MYR",
            "MZN",
            "NAD",
            "NGN",
            "NIO",
            "NOK",
            "NPR",
            "NZD",
            "OMR",
            "PAB",
            "PEN",
            "PGK",
            "PHP",
            "PKR",
            "PLN",
            "PYG",
            "QAR",
            "RON",
            "RSD",
            "RUB",
            "RWF",
            "SAR",
            "SBD",
            "SCR",
            "SDG",
            "SEK",
            "SGD",
            "SHP",
            "SLL",
            "SOS",
            "SRD",
            "SSP",
            "STD",
            "SVC",
            "SYP",
            "SZL",
            "THB",
            "TJS",
            "TMT",
            "TND",
            "TOP",
            "TRY",
            "TTD",
            "TWD",
            "TZS",
            "UAH",
            "UGX",
            "USD",
            "USN",
            "UYI",
            "UYU",
            "UZS",
            "VEF",
            "VND",
            "VUV",
            "WST",
            "XAF",
            "XAG",
            "XAU",
            "XBA",
            "XBB",
            "XBC",
            "XBD",
            "XCD",
            "XDR",
            "XOF",
            "XPD",
            "XPF",
            "XPT",
            "XSU",
            "XTS",
            "XUA",
            "XXX",
            "YER",
            "ZAR",
            "ZMW",
            "ZWL"
          ]
        },
        "totalMaximumFractionDigits": {
          "type": "number"
        },
        "totalMinimumFractionDigits": {
          "type": "number"
        },
        "renderAs": {
          "type": "string"
        }
      },
      "required": ["name"]
    },
    "matrixdropdown": {
      "type": "object",
      "$id": "matrixdropdown",
      "allOf": [
        {
          "$ref": "matrixdropdownbase"
        },
        {
          "properties": {
            "rows": {
              "type": "array",
              "items": {
                "$ref": "itemvalue"
              }
            },
            "rowTitleWidth": {
              "type": "string"
            },
            "totalText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "hideIfRowsEmpty": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "itemvalue": {
      "type": "object",
      "$id": "itemvalue",
      "properties": {
        "value": {
          "type": "string"
        },
        "text": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "visibleIf": {
          "type": "string"
        },
        "enableIf": {
          "type": "string"
        }
      },
      "required": ["value"]
    },
    "matrixdynamic": {
      "type": "object",
      "$id": "matrixdynamic",
      "allOf": [
        {
          "$ref": "matrixdropdownbase"
        },
        {
          "properties": {
            "allowAddRows": {
              "type": "boolean"
            },
            "allowRemoveRows": {
              "type": "boolean"
            },
            "rowCount": {
              "type": "number"
            },
            "minRowCount": {
              "type": "number"
            },
            "maxRowCount": {
              "type": "number"
            },
            "keyName": {
              "type": "string"
            },
            "defaultRowValue": {
              "type": "string"
            },
            "defaultValueFromLastRow": {
              "type": "boolean"
            },
            "confirmDelete": {
              "type": "boolean"
            },
            "confirmDeleteText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "addRowLocation": {
              "type": "string",
              "enum": ["default", "top", "bottom", "topBottom"]
            },
            "addRowText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "removeRowText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "hideColumnsIfEmpty": {
              "type": "boolean"
            },
            "emptyRowsText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "detailPanelShowOnAdding": {
              "type": "boolean"
            },
            "allowRowsDragAndDrop": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "matrix": {
      "type": "object",
      "$id": "matrix",
      "allOf": [
        {
          "$ref": "matrixbase"
        },
        {
          "properties": {
            "rowTitleWidth": {
              "type": "string"
            },
            "columns": {
              "type": "array",
              "items": {
                "$ref": "itemvalue"
              }
            },
            "rows": {
              "type": "array",
              "items": {
                "$ref": "itemvalue"
              }
            },
            "cells": {
              "type": "string"
            },
            "rowsOrder": {
              "type": "string",
              "enum": ["initial", "random"]
            },
            "isAllRowRequired": {
              "type": "boolean"
            },
            "eachRowUnique": {
              "type": "boolean"
            },
            "hideIfRowsEmpty": {
              "type": "boolean"
            },
            "cellComponent": {
              "type": "string"
            }
          }
        }
      ]
    },
    "expression": {
      "type": "object",
      "$id": "expression",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "expression": {
              "type": "string"
            },
            "format": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "displayStyle": {
              "type": "string",
              "enum": ["none", "decimal", "currency", "percent", "date"]
            },
            "currency": {
              "type": "string",
              "enum": [
                "AED",
                "AFN",
                "ALL",
                "AMD",
                "ANG",
                "AOA",
                "ARS",
                "AUD",
                "AWG",
                "AZN",
                "BAM",
                "BBD",
                "BDT",
                "BGN",
                "BHD",
                "BIF",
                "BMD",
                "BND",
                "BOB",
                "BOV",
                "BRL",
                "BSD",
                "BTN",
                "BWP",
                "BYN",
                "BZD",
                "CAD",
                "CDF",
                "CHE",
                "CHF",
                "CHW",
                "CLF",
                "CLP",
                "CNY",
                "COP",
                "COU",
                "CRC",
                "CUC",
                "CUP",
                "CVE",
                "CZK",
                "DJF",
                "DKK",
                "DOP",
                "DZD",
                "EGP",
                "ERN",
                "ETB",
                "EUR",
                "FJD",
                "FKP",
                "GBP",
                "GEL",
                "GHS",
                "GIP",
                "GMD",
                "GNF",
                "GTQ",
                "GYD",
                "HKD",
                "HNL",
                "HRK",
                "HTG",
                "HUF",
                "IDR",
                "ILS",
                "INR",
                "IQD",
                "IRR",
                "ISK",
                "JMD",
                "JOD",
                "JPY",
                "KES",
                "KGS",
                "KHR",
                "KMF",
                "KPW",
                "KRW",
                "KWD",
                "KYD",
                "KZT",
                "LAK",
                "LBP",
                "LKR",
                "LRD",
                "LSL",
                "LYD",
                "MAD",
                "MDL",
                "MGA",
                "MKD",
                "MMK",
                "MNT",
                "MOP",
                "MRO",
                "MUR",
                "MVR",
                "MWK",
                "MXN",
                "MXV",
                "MYR",
                "MZN",
                "NAD",
                "NGN",
                "NIO",
                "NOK",
                "NPR",
                "NZD",
                "OMR",
                "PAB",
                "PEN",
                "PGK",
                "PHP",
                "PKR",
                "PLN",
                "PYG",
                "QAR",
                "RON",
                "RSD",
                "RUB",
                "RWF",
                "SAR",
                "SBD",
                "SCR",
                "SDG",
                "SEK",
                "SGD",
                "SHP",
                "SLL",
                "SOS",
                "SRD",
                "SSP",
                "STD",
                "SVC",
                "SYP",
                "SZL",
                "THB",
                "TJS",
                "TMT",
                "TND",
                "TOP",
                "TRY",
                "TTD",
                "TWD",
                "TZS",
                "UAH",
                "UGX",
                "USD",
                "USN",
                "UYI",
                "UYU",
                "UZS",
                "VEF",
                "VND",
                "VUV",
                "WST",
                "XAF",
                "XAG",
                "XAU",
                "XBA",
                "XBB",
                "XBC",
                "XBD",
                "XCD",
                "XDR",
                "XOF",
                "XPD",
                "XPF",
                "XPT",
                "XSU",
                "XTS",
                "XUA",
                "XXX",
                "YER",
                "ZAR",
                "ZMW",
                "ZWL"
              ]
            },
            "maximumFractionDigits": {
              "type": "number"
            },
            "minimumFractionDigits": {
              "type": "number"
            },
            "useGrouping": {
              "type": "boolean"
            },
            "precision": {
              "type": "number"
            }
          }
        }
      ]
    },
    "selectbase": {
      "type": "object",
      "$id": "selectbase",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "choicesFromQuestion": {
              "type": "string"
            },
            "choices": {
              "type": "array",
              "items": {
                "$ref": "itemvalue"
              }
            },
            "choicesFromQuestionMode": {
              "type": "string",
              "enum": ["all", "selected", "unselected"]
            },
            "choiceValuesFromQuestion": {
              "type": "string"
            },
            "choiceTextsFromQuestion": {
              "type": "string"
            },
            "choicesOrder": {
              "type": "string",
              "enum": ["none", "asc", "desc", "random"]
            },
            "choicesByUrl": {
              "$ref": "choicesByUrl"
            },
            "hideIfChoicesEmpty": {
              "type": "boolean"
            },
            "choicesVisibleIf": {
              "type": "string"
            },
            "choicesEnableIf": {
              "type": "string"
            },
            "separateSpecialChoices": {
              "type": "boolean"
            },
            "showOtherItem": {
              "type": "boolean"
            },
            "showNoneItem": {
              "type": "boolean"
            },
            "showRefuseItem": {
              "type": "boolean"
            },
            "showDontKnowItem": {
              "type": "boolean"
            },
            "otherPlaceholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "noneText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "refuseText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "dontKnowText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "otherText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "otherErrorText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "storeOthersAsComment": {
              "type": "string",
              "enum": ["default", true, false]
            }
          }
        }
      ]
    },
    "choicesByUrl": {
      "type": "object",
      "$id": "choicesByUrl",
      "properties": {
        "url": {
          "type": "string"
        },
        "path": {
          "type": "string"
        },
        "valueName": {
          "type": "string"
        },
        "titleName": {
          "type": "string"
        },
        "imageLinkName": {
          "type": "string"
        },
        "allowEmptyResponse": {
          "type": "boolean"
        },
        "attachOriginalItems": {
          "type": "boolean"
        }
      }
    },
    "checkboxbase": {
      "type": "object",
      "$id": "checkboxbase",
      "allOf": [
        {
          "$ref": "selectbase"
        },
        {
          "properties": {
            "colCount": {
              "type": "number",
              "enum": [0, 1, 2, 3, 4, 5]
            }
          }
        }
      ]
    },
    "checkbox": {
      "type": "object",
      "$id": "checkbox",
      "allOf": [
        {
          "$ref": "checkboxbase"
        },
        {
          "properties": {
            "showSelectAllItem": {
              "type": "boolean"
            },
            "maxSelectedChoices": {
              "type": "number"
            },
            "minSelectedChoices": {
              "type": "number"
            },
            "selectAllText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "valuePropertyName": {
              "type": "string"
            },
            "itemComponent": {
              "type": "string"
            }
          }
        }
      ]
    },
    "tagbox": {
      "type": "object",
      "$id": "tagbox",
      "allOf": [
        {
          "$ref": "checkbox"
        },
        {
          "properties": {
            "placeholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "allowClear": {
              "type": "boolean"
            },
            "searchEnabled": {
              "type": "boolean"
            },
            "textWrapEnabled": {
              "type": "boolean"
            },
            "choicesLazyLoadEnabled": {
              "type": "boolean"
            },
            "choicesLazyLoadPageSize": {
              "type": "number"
            },
            "hideSelectedItems": {
              "type": "boolean"
            },
            "closeOnSelect": {
              "type": "boolean"
            },
            "searchMode": {
              "type": "string",
              "enum": ["contains", "startsWith"]
            }
          }
        }
      ]
    },
    "ranking": {
      "type": "object",
      "$id": "ranking",
      "allOf": [
        {
          "$ref": "checkbox"
        },
        {
          "properties": {
            "longTap": {
              "type": "string"
            },
            "selectToRankEnabled": {
              "type": "boolean"
            },
            "selectToRankSwapAreas": {
              "type": "boolean"
            },
            "selectToRankAreasLayout": {
              "type": "string",
              "enum": ["horizontal", "vertical"]
            },
            "selectToRankEmptyRankedAreaText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "selectToRankEmptyUnrankedAreaText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            }
          }
        }
      ]
    },
    "radiogroup": {
      "type": "object",
      "$id": "radiogroup",
      "allOf": [
        {
          "$ref": "checkboxbase"
        },
        {
          "properties": {
            "showClearButton": {
              "type": "boolean"
            },
            "itemComponent": {
              "type": "string"
            }
          }
        }
      ]
    },
    "imagepicker": {
      "type": "object",
      "$id": "imagepicker",
      "allOf": [
        {
          "$ref": "checkboxbase"
        },
        {
          "properties": {
            "optionsCaption": {
              "type": "string"
            },
            "contentMode": {
              "type": "string",
              "enum": ["image", "video"]
            },
            "imageFit": {
              "type": "string",
              "enum": ["none", "contain", "cover", "fill"]
            },
            "imageHeight": {
              "type": "number"
            },
            "imageWidth": {
              "type": "number"
            },
            "minImageWidth": {
              "type": "string"
            },
            "minImageHeight": {
              "type": "string"
            },
            "maxImageWidth": {
              "type": "string"
            },
            "maxImageHeight": {
              "type": "string"
            },
            "showLabel": {
              "type": "boolean"
            },
            "multiSelect": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "buttongroup": {
      "type": "object",
      "$id": "buttongroup",
      "allOf": [
        {
          "$ref": "checkboxbase"
        },
        {
          "properties": {}
        }
      ]
    },
    "dropdown": {
      "type": "object",
      "$id": "dropdown",
      "allOf": [
        {
          "$ref": "selectbase"
        },
        {
          "properties": {
            "placeholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "allowClear": {
              "type": "boolean"
            },
            "choicesMin": {
              "type": "number"
            },
            "choicesMax": {
              "type": "number"
            },
            "choicesStep": {
              "type": "number"
            },
            "autocomplete": {
              "type": "string",
              "enum": [
                "",
                "name",
                "honorific-prefix",
                "given-name",
                "additional-name",
                "family-name",
                "honorific-suffix",
                "nickname",
                "organization-title",
                "username",
                "new-password",
                "current-password",
                "organization",
                "street-address",
                "address-line1",
                "address-line2",
                "address-line3",
                "address-level4",
                "address-level3",
                "address-level2",
                "address-level1",
                "country",
                "country-name",
                "postal-code",
                "cc-name",
                "cc-given-name",
                "cc-additional-name",
                "cc-family-name",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc",
                "cc-type",
                "transaction-currency",
                "transaction-amount",
                "language",
                "bday",
                "bday-day",
                "bday-month",
                "bday-year",
                "sex",
                "url",
                "photo",
                "tel",
                "tel-country-code",
                "tel-national",
                "tel-area-code",
                "tel-local",
                "tel-local-prefix",
                "tel-local-suffix",
                "tel-extension",
                "email",
                "impp"
              ]
            },
            "textWrapEnabled": {
              "type": "boolean"
            },
            "searchEnabled": {
              "type": "boolean"
            },
            "searchMode": {
              "type": "string",
              "enum": ["contains", "startsWith"]
            },
            "choicesLazyLoadEnabled": {
              "type": "boolean"
            },
            "choicesLazyLoadPageSize": {
              "type": "number"
            },
            "inputFieldComponent": {
              "type": "string"
            },
            "itemComponent": {
              "type": "string"
            }
          }
        }
      ]
    },
    "textbase": {
      "type": "object",
      "$id": "textbase",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {}
        }
      ]
    },
    "text": {
      "type": "object",
      "$id": "text",
      "allOf": [
        {
          "$ref": "textbase"
        },
        {
          "properties": {
            "inputType": {
              "type": "string",
              "enum": [
                "color",
                "date",
                "datetime-local",
                "email",
                "month",
                "number",
                "password",
                "range",
                "tel",
                "text",
                "time",
                "url",
                "week"
              ]
            },
            "size": {
              "type": "number"
            },
            "textUpdateMode": {
              "type": "string",
              "enum": ["default", "onBlur", "onTyping"]
            },
            "autocomplete": {
              "type": "string",
              "enum": [
                "",
                "name",
                "honorific-prefix",
                "given-name",
                "additional-name",
                "family-name",
                "honorific-suffix",
                "nickname",
                "organization-title",
                "username",
                "new-password",
                "current-password",
                "organization",
                "street-address",
                "address-line1",
                "address-line2",
                "address-line3",
                "address-level4",
                "address-level3",
                "address-level2",
                "address-level1",
                "country",
                "country-name",
                "postal-code",
                "cc-name",
                "cc-given-name",
                "cc-additional-name",
                "cc-family-name",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc",
                "cc-type",
                "transaction-currency",
                "transaction-amount",
                "language",
                "bday",
                "bday-day",
                "bday-month",
                "bday-year",
                "sex",
                "url",
                "photo",
                "tel",
                "tel-country-code",
                "tel-national",
                "tel-area-code",
                "tel-local",
                "tel-local-prefix",
                "tel-local-suffix",
                "tel-extension",
                "email",
                "impp"
              ]
            },
            "min": {
              "type": "string"
            },
            "max": {
              "type": "string"
            },
            "minValueExpression": {
              "type": "string"
            },
            "maxValueExpression": {
              "type": "string"
            },
            "minErrorText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "maxErrorText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "inputTextAlignment": {
              "type": "string",
              "enum": ["left", "right", "auto"]
            },
            "maskType": {
              "type": "string",
              "enum": ["none", "pattern", "datetime", "numeric", "currency"]
            },
            "maskSettings": {
              "type": "array",
              "items": {
                "$ref": "masksettings"
              }
            },
            "step": {
              "type": "number"
            },
            "maxLength": {
              "type": "number"
            },
            "placeholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "dataList": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            }
          }
        }
      ]
    },
    "masksettings": {
      "type": "object",
      "$id": "masksettings",
      "properties": {
        "saveMaskedValue": {
          "type": "boolean"
        }
      }
    },
    "comment": {
      "type": "object",
      "$id": "comment",
      "allOf": [
        {
          "$ref": "textbase"
        },
        {
          "properties": {
            "maxLength": {
              "type": "number"
            },
            "cols": {
              "type": "number"
            },
            "rows": {
              "type": "number"
            },
            "placeholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "textUpdateMode": {
              "type": "string",
              "enum": ["default", "onBlur", "onTyping"]
            },
            "autoGrow": {
              "type": "boolean"
            },
            "allowResize": {
              "type": "boolean"
            },
            "acceptCarriageReturn": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "multipletext": {
      "type": "object",
      "$id": "multipletext",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "items": {
              "type": "array",
              "items": {
                "$ref": "multipletextitem"
              }
            },
            "itemSize": {
              "type": "number"
            },
            "colCount": {
              "type": "number",
              "enum": [1, 2, 3, 4, 5]
            },
            "itemErrorLocation": {
              "type": "string",
              "enum": ["default", "top", "bottom"]
            },
            "itemTitleWidth": {
              "type": "string"
            }
          }
        }
      ],
      "required": ["items"]
    },
    "multipletextitem": {
      "type": "object",
      "$id": "multipletextitem",
      "properties": {
        "name": {
          "type": "string"
        },
        "isRequired": {
          "type": "boolean"
        },
        "placeholder": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "inputType": {
          "type": "string",
          "enum": [
            "color",
            "date",
            "datetime-local",
            "email",
            "month",
            "number",
            "password",
            "range",
            "tel",
            "text",
            "time",
            "url",
            "week"
          ]
        },
        "maskType": {
          "type": "string",
          "enum": ["none", "pattern", "datetime", "numeric", "currency"]
        },
        "maskSettings": {
          "type": "array",
          "items": {
            "$ref": "masksettings"
          }
        },
        "inputTextAlignment": {
          "type": "string",
          "enum": ["left", "right", "auto"]
        },
        "title": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "maxLength": {
          "type": "number"
        },
        "size": {
          "type": "number"
        },
        "requiredErrorText": {
          "oneOf": [
            {
              "type": "string"
            },
            {
              "$ref": "locstring"
            }
          ]
        },
        "defaultValueExpression": {
          "type": "string"
        },
        "minValueExpression": {
          "type": "string"
        },
        "maxValueExpression": {
          "type": "string"
        },
        "validators": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "numericvalidator"
              },
              {
                "$ref": "textvalidator"
              },
              {
                "$ref": "answercountvalidator"
              },
              {
                "$ref": "regexvalidator"
              },
              {
                "$ref": "emailvalidator"
              },
              {
                "$ref": "expressionvalidator"
              }
            ]
          }
        }
      },
      "required": ["name"]
    },
    "nonvalue": {
      "type": "object",
      "$id": "nonvalue",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {}
        }
      ]
    },
    "html": {
      "type": "object",
      "$id": "html",
      "allOf": [
        {
          "$ref": "nonvalue"
        },
        {
          "properties": {
            "html": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            }
          }
        }
      ]
    },
    "image": {
      "type": "object",
      "$id": "image",
      "allOf": [
        {
          "$ref": "nonvalue"
        },
        {
          "properties": {
            "imageLink": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "altText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "contentMode": {
              "type": "string",
              "enum": ["auto", "image", "video", "youtube"]
            },
            "imageFit": {
              "type": "string",
              "enum": ["none", "contain", "cover", "fill"]
            },
            "imageHeight": {
              "type": "string"
            },
            "imageWidth": {
              "type": "string"
            }
          }
        }
      ]
    },
    "empty": {
      "type": "object",
      "$id": "empty",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {}
        }
      ]
    },
    "file": {
      "type": "object",
      "$id": "file",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "showPreview": {
              "type": "boolean"
            },
            "allowMultiple": {
              "type": "boolean"
            },
            "allowImagesPreview": {
              "type": "boolean"
            },
            "imageHeight": {
              "type": "string"
            },
            "imageWidth": {
              "type": "string"
            },
            "acceptedTypes": {
              "type": "string"
            },
            "storeDataAsText": {
              "type": "boolean"
            },
            "waitForUpload": {
              "type": "boolean"
            },
            "maxSize": {
              "type": "number"
            },
            "needConfirmRemoveFile": {
              "type": "boolean"
            },
            "sourceType": {
              "type": "string",
              "enum": ["file", "camera", "file-camera"]
            },
            "fileOrPhotoPlaceholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "photoPlaceholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "filePlaceholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "allowCameraAccess": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "rating": {
      "type": "object",
      "$id": "rating",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "rateType": {
              "type": "string",
              "enum": ["labels", "stars", "smileys"]
            },
            "scaleColorMode": {
              "type": "string",
              "enum": ["monochrome", "colored"]
            },
            "rateColorMode": {
              "type": "string",
              "enum": ["default", "scale"]
            },
            "autoGenerate": {
              "type": "string",
              "enum": [true, false]
            },
            "rateCount": {
              "type": "number"
            },
            "rateValues": {
              "type": "array",
              "items": {
                "$ref": "itemvalue"
              }
            },
            "rateMin": {
              "type": "number"
            },
            "rateMax": {
              "type": "number"
            },
            "rateStep": {
              "type": "number"
            },
            "minRateDescription": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "maxRateDescription": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "displayRateDescriptionsAsExtremeItems": {
              "type": "boolean"
            },
            "rateDescriptionLocation": {
              "type": "string",
              "enum": ["leftRight", "top", "bottom", "topBottom"]
            },
            "displayMode": {
              "type": "string",
              "enum": ["auto", "buttons", "dropdown"]
            },
            "itemComponent": {
              "type": "string"
            }
          }
        }
      ]
    },
    "boolean": {
      "type": "object",
      "$id": "boolean",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "label": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "labelTrue": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "labelFalse": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "valueTrue": {
              "type": "string"
            },
            "valueFalse": {
              "type": "string"
            },
            "swapOrder": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "signaturepad": {
      "type": "object",
      "$id": "signaturepad",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "signatureWidth": {
              "type": "number"
            },
            "signatureHeight": {
              "type": "number"
            },
            "signatureAutoScaleEnabled": {
              "type": "boolean"
            },
            "penMinWidth": {
              "type": "number"
            },
            "penMaxWidth": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "allowClear": {
              "type": "boolean"
            },
            "showPlaceholder": {
              "type": "boolean"
            },
            "placeholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "placeholderReadOnly": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "backgroundImage": {
              "type": "string"
            },
            "penColor": {
              "type": "string"
            },
            "backgroundColor": {
              "type": "string"
            },
            "dataFormat": {
              "type": "string",
              "enum": ["png", "image/jpeg", "image/svg+xml"]
            },
            "storeDataAsText": {
              "type": "boolean"
            },
            "waitForUpload": {
              "type": "boolean"
            }
          }
        }
      ]
    },
    "paneldynamic": {
      "type": "object",
      "$id": "paneldynamic",
      "allOf": [
        {
          "$ref": "question"
        },
        {
          "properties": {
            "templateElements": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "$ref": "matrixdropdownbase"
                  },
                  {
                    "$ref": "matrixdropdown"
                  },
                  {
                    "$ref": "matrixdynamic"
                  },
                  {
                    "$ref": "matrix"
                  },
                  {
                    "$ref": "expression"
                  },
                  {
                    "$ref": "checkbox"
                  },
                  {
                    "$ref": "tagbox"
                  },
                  {
                    "$ref": "ranking"
                  },
                  {
                    "$ref": "radiogroup"
                  },
                  {
                    "$ref": "imagepicker"
                  },
                  {
                    "$ref": "buttongroup"
                  },
                  {
                    "$ref": "dropdown"
                  },
                  {
                    "$ref": "textbase"
                  },
                  {
                    "$ref": "text"
                  },
                  {
                    "$ref": "comment"
                  },
                  {
                    "$ref": "multipletext"
                  },
                  {
                    "$ref": "nonvalue"
                  },
                  {
                    "$ref": "html"
                  },
                  {
                    "$ref": "image"
                  },
                  {
                    "$ref": "empty"
                  },
                  {
                    "$ref": "file"
                  },
                  {
                    "$ref": "rating"
                  },
                  {
                    "$ref": "boolean"
                  },
                  {
                    "$ref": "signaturepad"
                  },
                  {
                    "$ref": "paneldynamic"
                  },
                  {
                    "$ref": "panel"
                  }
                ]
              }
            },
            "templateTitle": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "templateTabTitle": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "tabTitlePlaceholder": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "templateDescription": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "noEntriesText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "allowAddPanel": {
              "type": "boolean"
            },
            "allowRemovePanel": {
              "type": "boolean"
            },
            "newPanelPosition": {
              "type": "string",
              "enum": ["next", "last"]
            },
            "panelCount": {
              "type": "number",
              "enum": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
            },
            "minPanelCount": {
              "type": "number"
            },
            "maxPanelCount": {
              "type": "number"
            },
            "defaultPanelValue": {
              "type": "string"
            },
            "defaultValueFromLastPanel": {
              "type": "boolean"
            },
            "panelsState": {
              "type": "string",
              "enum": ["default", "collapsed", "expanded", "firstExpanded"]
            },
            "keyName": {
              "type": "string"
            },
            "keyDuplicationError": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "confirmDelete": {
              "type": "boolean"
            },
            "confirmDeleteText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "panelAddText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "panelRemoveText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "panelPrevText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "panelNextText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "showQuestionNumbers": {
              "type": "string",
              "enum": ["off", "onPanel", "onSurvey"]
            },
            "showRangeInProgress": {
              "type": "boolean"
            },
            "renderMode": {
              "type": "string",
              "enum": ["list", "progressTop", "progressBottom", "progressTopBottom", "tab"]
            },
            "displayMode": {
              "type": "string",
              "enum": ["list", "carousel", "tab"]
            },
            "showProgressBar": {
              "type": "boolean"
            },
            "progressBarLocation": {
              "type": "string",
              "enum": ["top", "bottom", "topBottom"]
            },
            "tabAlign": {
              "type": "string",
              "enum": ["left", "center", "right"]
            },
            "templateTitleLocation": {
              "type": "string",
              "enum": ["default", "top", "bottom", "left"]
            },
            "templateErrorLocation": {
              "type": "string",
              "enum": ["default", "top", "bottom"]
            },
            "templateVisibleIf": {
              "type": "string"
            },
            "panelRemoveButtonLocation": {
              "type": "string",
              "enum": ["bottom", "right"]
            }
          }
        }
      ]
    },
    "panel": {
      "type": "object",
      "$id": "panel",
      "allOf": [
        {
          "$ref": "panelbase"
        },
        {
          "properties": {
            "type": {
              "type": "string"
            },
            "state": {
              "type": "string",
              "enum": ["default", "collapsed", "expanded"]
            },
            "isRequired": {
              "type": "boolean"
            },
            "requiredErrorText": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "startWithNewLine": {
              "type": "boolean"
            },
            "width": {
              "type": "string"
            },
            "minWidth": {
              "type": "string"
            },
            "maxWidth": {
              "type": "string"
            },
            "colSpan": {
              "type": "number"
            },
            "effectiveColSpan": {
              "type": "number"
            },
            "innerIndent": {
              "type": "number",
              "enum": [0, 1, 2, 3]
            },
            "indent": {
              "type": "number",
              "enum": [0, 1, 2, 3]
            },
            "page": {
              "type": "string"
            },
            "showNumber": {
              "type": "boolean"
            },
            "showQuestionNumbers": {
              "type": "string",
              "enum": ["default", "onpanel", "off"]
            },
            "questionStartIndex": {
              "type": "string"
            },
            "allowAdaptiveActions": {
              "type": "boolean"
            }
          }
        }
      ],
      "required": ["type"]
    },
    "panellayoutcolumn": {
      "type": "object",
      "$id": "panellayoutcolumn",
      "properties": {
        "effectiveWidth": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "questionTitleWidth": {
          "type": "string"
        }
      }
    },
    "page": {
      "type": "object",
      "$id": "page",
      "allOf": [
        {
          "$ref": "panelbase"
        },
        {
          "properties": {
            "navigationButtonsVisibility": {
              "type": "string",
              "enum": ["inherit", "show", "hide"]
            },
            "maxTimeToFinish": {
              "type": "number"
            },
            "navigationTitle": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            },
            "navigationDescription": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            }
          }
        }
      ]
    },
    "trigger": {
      "type": "object",
      "$id": "trigger",
      "properties": {
        "operator": {
          "type": "string"
        },
        "value": {
          "type": "string"
        },
        "expression": {
          "type": "string"
        }
      }
    },
    "surveytrigger": {
      "type": "object",
      "$id": "surveytrigger",
      "allOf": [
        {
          "$ref": "trigger"
        },
        {
          "properties": {
            "name": {
              "type": "string"
            }
          }
        }
      ]
    },
    "visibletrigger": {
      "type": "object",
      "$id": "visibletrigger",
      "allOf": [
        {
          "$ref": "surveytrigger"
        },
        {
          "properties": {
            "pages": {
              "type": "string"
            },
            "questions": {
              "type": "string"
            }
          }
        }
      ]
    },
    "completetrigger": {
      "type": "object",
      "$id": "completetrigger",
      "allOf": [
        {
          "$ref": "surveytrigger"
        },
        {
          "properties": {}
        }
      ]
    },
    "setvaluetrigger": {
      "type": "object",
      "$id": "setvaluetrigger",
      "allOf": [
        {
          "$ref": "surveytrigger"
        },
        {
          "properties": {
            "setToName": {
              "type": "string"
            },
            "setValue": {
              "type": "string"
            },
            "isVariable": {
              "type": "boolean"
            }
          }
        }
      ],
      "required": ["setToName"]
    },
    "copyvaluetrigger": {
      "type": "object",
      "$id": "copyvaluetrigger",
      "allOf": [
        {
          "$ref": "surveytrigger"
        },
        {
          "properties": {
            "fromName": {
              "type": "string"
            },
            "setToName": {
              "type": "string"
            },
            "copyDisplayValue": {
              "type": "boolean"
            }
          }
        }
      ],
      "required": ["fromName", "setToName"]
    },
    "skiptrigger": {
      "type": "object",
      "$id": "skiptrigger",
      "allOf": [
        {
          "$ref": "surveytrigger"
        },
        {
          "properties": {
            "gotoName": {
              "type": "string"
            }
          }
        }
      ],
      "required": ["gotoName"]
    },
    "runexpressiontrigger": {
      "type": "object",
      "$id": "runexpressiontrigger",
      "allOf": [
        {
          "$ref": "surveytrigger"
        },
        {
          "properties": {
            "setToName": {
              "type": "string"
            },
            "runExpression": {
              "type": "string"
            }
          }
        }
      ]
    },
    "calculatedvalue": {
      "type": "object",
      "$id": "calculatedvalue",
      "properties": {
        "name": {
          "type": "string"
        },
        "expression": {
          "type": "string"
        },
        "includeIntoResult": {
          "type": "boolean"
        }
      },
      "required": ["name"]
    },
    "urlconditionitem": {
      "type": "object",
      "$id": "urlconditionitem",
      "allOf": [
        {
          "$ref": "expressionitem"
        },
        {
          "properties": {
            "url": {
              "oneOf": [
                {
                  "type": "string"
                },
                {
                  "$ref": "locstring"
                }
              ]
            }
          }
        }
      ]
    }
  }
}
